var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verification-notice"},[_c('h1',[_vm._v("Email Already Verified")]),_c('p',{staticClass:"email-desc"},[_vm._v("Your email has already been verified. No further action is required.")])])
}]

export { render, staticRenderFns }